import styled from 'styled-components'
import { themeGet } from 'styled-system'
import { Field } from 'formik'
import { BodyCopy, HeaderTwo, WarningIcon } from 'secondstep-components'

export const DescriptionText = styled(BodyCopy)`
  font-size: 1rem;
  font-family: ${themeGet('font.molde.regular')};
  color: ${themeGet('colors.darkGray')};
  margin-bottom: 1.313rem;
`

export const LabelText = styled(BodyCopy)`
  p:not(:last-child) {
    margin-block-end: 0;
  }

  strong {
    font-family: ${themeGet('font.molde.medium')};
  }
`

export const ErrorText = styled.span`
  display: flex;
  align-items: center;
  font-size: 0.75rem;
  margin-top: 0.5rem;
  color: ${themeGet('colors.errorRed')};
`

export const FieldWrapper = styled.div`
  display: flex;
  align-items: flex-start;

  :not(:last-child) {
    margin-bottom: 1.063rem;
  }

  input[type='radio'] {
    display: none;
  }
`

export const HeaderText = styled(HeaderTwo)`
  margin-top: 2rem;
  margin-bottom: 0.563;
  font-size: 1.4375rem;
  font-family: ${themeGet('font.sharpSlab.semibold')};

  ${themeGet('breakpoints.mobile')} {
    font-size: 1.438rem;
    margin-bottom: 0.375rem;
  }
`

export const Label = styled.label`
  margin-top: 0;
  margin-left: 0.5rem;
  font-size: 1rem;
  color: ${themeGet('colors.darkGray')};
  width: 94%;
`

export const QuestionText = styled.span`
  font-size: 1rem;
  font-family: ${themeGet('font.sharpSlab.semibold')};
  color: ${themeGet('colors.darkBlue')};
  margin-bottom: 0.375rem;
`

export const QuestionWrapper = styled.div`
  display: flex;
  flex-direction: column;
  padding: 0.875rem 1.25rem 0.813rem;
  margin-bottom: 1.25rem;
  border-radius: 0.625rem;
  background-color: ${themeGet('colors.paleGray')};
`

export const RadioField = styled(Field).attrs(props => ({
  'data-testId': `radio-field-${props.id}`,
}))``

export const RadioCircle = styled.label`
  display: inline-block;
  position: relative;
  width: 18px;
  height: 18px;
  border: 2px solid ${themeGet('colors.blue')};
  border-radius: 50%;
  cursor: pointer;
  background-color: ${themeGet('colors.white')};
  margin-top: 0.125rem;

  &::after {
    content: '';
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    width: 0;
    height: 0;
    border-radius: 50%;
    background-color: ${themeGet('colors.darkBlue')};
    transition: width 0.2s, height 0.2s;
  }

  ${RadioField}:checked + &::after {
    width: 12px;
    height: 12px;
  }
`

export const SelectionsWrapper = styled.div`
  display: flex;
  flex-direction: column;
  margin-top: 0.5rem;
`

export const StyledHr = styled.hr`
  width: 100%;
  height: 2px;
  border: none;
  background-color: ${themeGet('colors.white')};
`

export const StyledWarningIcon = styled(WarningIcon)`
  width: 14px;
  height: 14px;
  margin-right: 0.25rem;
  margin-bottom: 0.1875rem;
  color: ${themeGet('colors.errorRed')};
`
